import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ExtraExpensesControllerFindAll$Params } from '@klubovna/api-client';
import { CreateExtraExpenseDto, UpdateExtraExpenseDto } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as ExtraExpensesActions from './extra-expenses.actions';
import * as ExtraExpensesSelectors from './extra-expenses.selectors';

@Injectable({
  providedIn: 'root',
})
export class ExtraExpensesFacade {
  private store = inject(Store);

  expenses$ = this.store.select(ExtraExpensesSelectors.selectAllExpenses);
  loading$ = this.store.select(ExtraExpensesSelectors.selectExtraExpensesLoading);
  error$ = this.store.select(ExtraExpensesSelectors.selectExtraExpensesError);
  pagination$ = this.store.select(ExtraExpensesSelectors.selectExtraExpensesPagination);
  params$ = this.store.select(ExtraExpensesSelectors.selectExtraExpensesParams);

  expenses = toSignal(this.expenses$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });
  pagination = toSignal(this.pagination$);
  params = toSignal(this.params$);

  loadExpenses(params?: ExtraExpensesControllerFindAll$Params): void {
    this.store.dispatch(ExtraExpensesActions.loadExpenses({ params }));
  }

  createExpense(dto: CreateExtraExpenseDto): void {
    this.store.dispatch(ExtraExpensesActions.createExpense({ dto }));
  }

  updateExpense(id: string, dto: UpdateExtraExpenseDto): void {
    this.store.dispatch(ExtraExpensesActions.updateExpense({ id, dto }));
  }

  deleteExpense(id: string): void {
    this.store.dispatch(ExtraExpensesActions.deleteExpense({ id }));
  }
}
